import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"
import { CookiesProvider } from "react-cookie"
import "./ParkingApp.css"
import config from "react-global-configuration"
import localConfig from "./constants/config.json"
import localContent from "./constants/content.json"
import ScrollToTop from "./components/common/ScrollToTop"
import ReactHtmlParser from "react-html-parser"
// import registerServiceWorker from './registerServiceWorker';
//import BookingJourney from './components/BookingJourney'
const BookingJourney = React.lazy(() => import(/* webpackPrefetch: true */ "./components/BookingJourney"))

export default class ParkingApp {
  constructor() {
    this.init()
    this.content = {}
    return this
  }
  init() {
    const parkingContainer = document.querySelector("[data-parking-root]")
    if (parkingContainer) {
      this.setGlobalParkingConfig(parkingContainer)

      const modelJson = (parkingContainer.dataset.modelJson && JSON.parse(parkingContainer.dataset.modelJson)) || {}
      const locale = (document.body && document.body.dataset.language) || "da"
      const loginState = (parkingContainer.dataset.loginState && JSON.parse(parkingContainer.dataset.loginState)) || {}
      const searchConfig = (parkingContainer.dataset.inputSearch && JSON.parse(parkingContainer.dataset.inputSearch)) || {}
      const languages = (parkingContainer.dataset.languages && JSON.parse(parkingContainer.dataset.languages)) || {}
      const consents = (parkingContainer.dataset.parkingConsents && JSON.parse(parkingContainer.dataset.parkingConsents)) || {}

      ReactDOM.render(
        <CookiesProvider>
          <BrowserRouter>
            <ScrollToTop>
              <Suspense fallback={ReactHtmlParser(parkingContainer.innerHTML)}>
                <BookingJourney
                  priceFormatter={(price, hideCurrency) =>
                    `${new Intl.NumberFormat("da-DK", { style: "decimal", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(price)}${
                      hideCurrency ? "" : " DKK"
                    }`
                  }
                  content={this.content}
                  languages={languages}
                  locale={locale}
                  onlyTopLevel={modelJson.disableMegaMenu}
                  loginState={loginState}
                  searchConfig={searchConfig}
                  headerData={modelJson}
                  consentContent={consents}
                />
              </Suspense>
            </ScrollToTop>
          </BrowserRouter>
        </CookiesProvider>,
        parkingContainer,
      )
      //      registerServiceWorker();
    }
  }

  setGlobalParkingConfig = (container) => {
    let configFromEpi = container.dataset.parkingRoot
    if (!configFromEpi) {
      configFromEpi = localConfig
    } else {
      configFromEpi = JSON.parse(configFromEpi)
    }
    config.set(configFromEpi)
    let contentFromEpi = container.dataset.parkingProductContent
    if (!contentFromEpi) {
      this.content = localContent
    } else {
      this.content = JSON.parse(contentFromEpi)
    }
  }
}
//window.parkingApp = new ParkingApp()
